import React from 'react'
import { Link } from 'react-router-dom'

const Uif = () => {
   return (
      <>
         <div className="row mb-title">
            <div className="col s12 m12 l12 x12">
               <h5><b>UNIDAD DE INFORMACIÓN FINANCIERA</b></h5>
            </div>
         </div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución UIF 28/2018</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <Link to="http://servicios.infoleg.gob.ar/infolegInternet/anexos/305000-309999/308385/norma.htm" target="_blank" class="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </Link>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución UIF 11/2011</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <Link to="http://servicios.infoleg.gob.ar/infolegInternet/anexos/175000-179999/177979/norma.htm" target="_blank" class="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </Link>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución UIF 52/2012</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <Link to="http://servicios.infoleg.gob.ar/infolegInternet/anexos/195000-199999/195785/norma.htm" target="_blank" class="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </Link>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
      </>
   )
}

export default Uif